import { render, staticRenderFns } from "./VTextArea.vue?vue&type=template&id=98628416&scoped=true&"
import script from "./VTextArea.vue?vue&type=script&lang=js&"
export * from "./VTextArea.vue?vue&type=script&lang=js&"
import style0 from "./VTextArea.vue?vue&type=style&index=0&id=98628416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98628416",
  null
  
)

export default component.exports